import { Typography, Stack, Paper, useTheme, useMediaQuery } from "@mui/material";
import { useEffect } from "react";
import Content from "../Layout/Content";
import { useClientPortalConfigContext } from "../../context";
import LoadingOverlay from "../Shared/LoadingOverlay";
import FormItem from "./FormItem";
import NoForms from "./NoForms";
import { useForms } from "./hooks/useForms";
import { getUsersTimeZone } from "../../utils/timeZoneUtils";
import { useAnalytics } from "../../hooks/useAnalytics";

export default function Forms() {
    const { clientPortalGuid } = useClientPortalConfigContext();
    const { data, isLoading } = useForms(clientPortalGuid);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const { track } = useAnalytics();

    useEffect(() => {
        track("page_view", { page_title: "Forms" });
    }, [track]);

    return (
        <Content dataTestIdSuffix="forms">
            {isLoading ? (
                <LoadingOverlay />
            ) : (
                <Stack p={isMobile ? 2 : 4} spacing={2}>
                    <Stack>
                        <Typography variant="h6" fontWeight="bold">
                            Forms
                        </Typography>
                        <Typography variant="caption">All times are in {getUsersTimeZone()}</Typography>
                    </Stack>
                    <Paper>
                        <Stack spacing={2} p={isMobile ? 2 : 4}>
                            {data.forms && data.forms.length > 0 ? (
                                <Stack spacing={1}>
                                    {data.forms.map((form) => (
                                        <FormItem key={form.customFormDataNumber} form={form} />
                                    ))}
                                </Stack>
                            ) : (
                                <NoForms />
                            )}
                        </Stack>
                    </Paper>
                </Stack>
            )}
        </Content>
    );
}
